<template>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-btn block href="#" v-b-toggle.collapse1 variant="secondary">
                    Amplitude Forcings
                    <span class="when-opened">
                        <font-awesome-icon icon="chevron-down" />
                    </span>
                    <span class="when-closed">
                        <font-awesome-icon icon="chevron-right" />
                    </span>
                </b-btn>
            </b-card-header>

            <b-collapse visible id="collapse1" role="tabpanel">
                <b-card-body class="input">

                    <b-row>
                        <b-col>
                            <label>El Niño</label>
                            <b-form-input class="slider" type="range" min="0" max="2" step="0.2"
                                          v-model="amplitudes.enso" @change="update()"></b-form-input>
                            <div class="amp-value">{{ amplitudes.enso }}</div>
                        </b-col>
                        <b-col>
                            <label>Volcanic</label>
                            <b-form-input class="slider" type="range" min="0" max="2" step="0.2"
                                          v-model="amplitudes.volc" @change="update()"></b-form-input>
                            <div class="amp-value">{{ amplitudes.volc }}</div>
                        </b-col>

                        <!--Do not break if device screen is greater or equal to small-->
                        <div class="w-100 d-sm-none"></div>

                        <b-col>
                            <label>Solar</label>
                            <b-form-input class="slider" type="range" min="0" max="2" step="0.2"
                                          v-model="amplitudes.sol" @change="update()"></b-form-input>
                            <div class="amp-value">{{ amplitudes.sol }}</div>
                        </b-col>
                        <b-col>
                            <label>Anthropogenic</label>
                            <b-form-input class="slider" type="range" min="0" max="2" step="0.2"
                                          v-model="amplitudes.anth" @change="update()"></b-form-input>
                            <div class="amp-value">{{ amplitudes.anth }}</div>
                        </b-col>
                    </b-row>

                    <b-button variant="secondary" v-on:click=reset()>Reset</b-button>

                </b-card-body>
            </b-collapse>
        </b-card>

</template>

<script>

    export default {
        name: "Amplitudes",

        data() {
            return { amplitudes: { enso: 0.2, volc: 0.2, sol: 0.2, anth: 0.2 } }
        },

        methods: {
            update: function(){
                this.$emit("updateAmplitudes", this.amplitudes);
            },
            reset: function(){
                this.amplitudes = { enso: 0.2, volc: 0.2, sol: 0.2, anth: 0.2 };
                this.update();
            }
        }
    }

</script>

<style scoped>

    .slider {
        min-width: 94px; /* Slider isn't useful if too narrow */
    }

    .amp-value {
        text-align: center;
    }

    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }

</style>
